export const API_URL = process.env.REACT_APP_API_URL || '/api/game/';
export const API_URL_IMG = process.env.REACT_APP_API_URL_IMG || 'http://localhost:5001';

/**
 * Enderecos dos tres modulos de campo.
 *
 * Estavam escritos a mao dentro de Modules.tsx, quatro deles em http:// — o que e indefensavel
 * assim que um link de terminal trafegar por eles. Aqui ficam num lugar so, em https, e podem
 * ser trocados por ambiente sem mexer em codigo de tela.
 *
 * Ainda e configuracao de build, nao de admin. Quando a plataforma tiver dominio por evento,
 * isto passa a vir do proprio evento — e este bloco sai.
 */
export const MODULOS = {
  credenciamento:
    process.env.REACT_APP_URL_CREDENCIAMENTO || 'https://credenciamento.quantictechnology.com.br',
  autoatendimento:
    process.env.REACT_APP_URL_AUTOATENDIMENTO || 'https://autoatendimento.quantictechnology.com.br',
  acesso: process.env.REACT_APP_URL_ACESSO || 'https://acesso.quantictechnology.com.br',
} as const;
